import { Component, OnInit } from '@angular/core';
import { RequiredValidator } from '@angular/forms';
import { ServiceLayer } from 'src/app/services/serviceLayer';
declare var require:any;
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
  public needSupport:any;
  public bfmSupport:any;
  public ServiceCenter:any;
  public Billing:any;
  public claims:any;
  public RiskControl:any;
  public UnderWriterDetails:any;
  public jp = require("jsonpath")
  public IID;
  constructor(private serviceLayer: ServiceLayer) { }

  async ngOnInit() {
    await this.getUnderWriterInfoDetails()
    // this.getUnderWriterInfo();
  }
  async getUnderWriterInfoDetails() {
    // this.needSupport = null;
    // this.needSupport = JSON.parse(window.localStorage.getItem("UnderWriterInfo"));
    // if(this.needSupport == undefined || this.needSupport == null) {
      this.UnderWriterDetails = JSON.parse(window.localStorage.getItem("UnderWriterInfo"));
      if(this.UnderWriterDetails == undefined)
      {
        this.IID = setInterval(async() => {
          var loginDetails = JSON.parse(window.localStorage.getItem("loginUserDetails"));
          if(loginDetails != undefined && loginDetails.accessToken != undefined){
            clearInterval(this.IID);
            this.UnderWriterDetails = await this.serviceLayer.getUnderWriterInformation();
            this.processUnderWriterDetails(this.UnderWriterDetails);
          }              
        },1000);
      }
      else {
        this.processUnderWriterDetails(this.UnderWriterDetails);
      }
  }

  processUnderWriterDetails(UnderWriterDetails: any) {
    if (UnderWriterDetails?.bfmSupportInformation != undefined && UnderWriterDetails?.bfmSupportInformation?.length > 0) {
      window.localStorage.setItem("UnderWriterInformation", JSON.stringify(UnderWriterDetails));
      window.localStorage.setItem("UnderWriterInfo", JSON.stringify(UnderWriterDetails));
      this.getUnderWriterInfo(UnderWriterDetails);
      this.bfmSupport = UnderWriterDetails.bfmSupportInformation[0];
      if (this.bfmSupport?.length > 0) {
        this.bfmSupport = this.bfmSupport[0];
      }
    }
  }

  getUnderWriterInfo(data){
    this.needSupport = data;
    if(this.needSupport != undefined && this.needSupport.bfmSupportInformation != undefined && this.needSupport.bfmSupportInformation.length>0) {
        this.Billing = this.jp.query(this.needSupport.bfmSupportInformation,"$..[?(@.name =='Billing')]")[0];
        this.ServiceCenter = this.jp.query(this.needSupport.bfmSupportInformation,"$..[?(@.name =='Berkley Fire & Marine Support')]")[0];
        this.claims = this.jp.query(this.needSupport.bfmSupportInformation,"$..[?(@.name =='Claims')]")[0];
        this.RiskControl = this.jp.query(this.needSupport.bfmSupportInformation,"$..[?(@.name =='Risk Control')]")[0];
    }
  }

}
